// extracted by mini-css-extract-plugin
export default {"styleChooserSection":"y4-z","dimensionLabel":"z4-z","styleChooserControlWrapper":"A4-z","styleChooserControl":"B4-z","disabled":"C4-z","giftCard":"D4-z","styleChooserText":"E4-z"};